import { Component, inject, input, output } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-search-input',
  imports: [
    ReactiveFormsModule,
    FontAwesomeModule
  ],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss'
})
export class SearchInputComponent {
  private readonly formBuilder = inject(NonNullableFormBuilder);
  faSearch = faSearch;

  readonly loading = input<boolean>(false);
  readonly isFollowUp = input<boolean>(false);

  searchChange = output<string>();

  searchForm = this.formBuilder.group({
    query: ['', Validators.required]
  });

  submit() {
    const query = this.searchForm.getRawValue().query;
    this.searchChange.emit(query);
    this.searchForm.reset();
  }
}
